import axios from '@/api/axios';
import { defineStore } from 'pinia';
import Conversation from './Conversation';

export default defineStore('conversations', {
	state: () => ({
		conversations: [] as Conversation[],
		loading: false,
	}),
	actions: {
		async fetchConversations() {
			this.loading = true;
			try {
				const res = await axios.get('/chat/conversations');
				this.conversations = res.data;
			} catch (e) {
				console.error(e);
			} finally {
				this.loading = false;
			}
		},

		async fetchConversation(uuid: string) {
			try {
				const res = await axios.get(`/chat/conversations/${uuid}`);
				return res.data;
			} catch (e) {
				console.error(e);
				return null;
			}
		},
	},
});
